import { useParams } from "react-router-dom";
import styles from "../../Styles/Itinerary.module.scss";
import pictureOne from "./../../img/Poland/Itimerary_1.jpeg";
import pictureTwo from "./../../img/Poland/Itinerary_2.jpeg";
import pictureThree from "./../../img/Poland/Itinerary_3.jpeg";

function PolandItinerary() {
  const params = useParams();

  let dates = "";
  let trip = [];

  const tripAugust = [
    {
      day: "Day 1 - Monday, August 17",
      text: "Depart USA for Warsaw, Poland"
    },
    {
      day: "Day 2 - Tuesday, August 18",
      text: "Arrive to Warsaw and get settled into our hotel (overnight in Warsaw)"
    },
    {
      day: "Day 3 - Wednesday, August 19",
      text: "Tour the historical center of Warsaw with a local guide, visiting both the Old Town and the Warsaw Ghetto. During the Warsaw Uprising in August 1944, more than 85% of Warsaw’s historic center was destroyed by Nazi troops. After the war, a five-year reconstruction campaign by its citizens resulted in today’s meticulous restoration of the Old Town, with its churches, palaces, and marketplace. The Warsaw Ghetto was the largest of the Nazi ghettos during World War II and the Holocaust. It was established in November 1940 by the German authorities. At its height, as many as 460,000 Jews were imprisoned there, in an area of 1.3 sq mi, with an average of 9.2 persons per room, barely subsisting on meager food rations. From the Warsaw Ghetto, Jews were deported to Nazi concentration camps and mass-killing centers. In the summer of 1942, at least 254,000 ghetto residents were sent to the Treblinka extermination camp. (overnight in Warsaw)"
    },
    {
      day: "Day 4 - Thursday, August 20",
      text: "Ride a bus from Warsaw to Krakow (4.5 hrs). In the evening, we will stroll through the Main Market Square, the biggest Medieval Plaza in Europe. Its 40,000 square meters are truly astonishing. It was designed in 1257, is considered Kraków’s city center and has an important historical, cultural, and social significance. The entire medieval old town is among the first sites chosen for UNESCO’s original World Heritage List. (overnight in Krakow)"
    },
    {
      day: "Day 5 - Friday, August 21",
      text: "In the morning tour Wawel Hill. In 1978 Wawel was declared the first World Heritage Site as part of the historic center of Kraków. For centuries the residence of the kings of Poland and the symbol of Polish statehood, Wawel Castle is now one of the country’s premier art museums. In the afternoon a Oscar Schindlers’ factory tour. The Oscar Schindler’s Enamel Factory is where 1,200 Jews were employed by Schindler and whose lives were subsequently saved from the death camps. This factory is now a museum. (overnight in Krakow)"
    },
    {
      day: "Day 6 - Saturday, August 22",
      text: "Tour Auschwitz/Birkenau, the largest of the Nazi concentration and extermination camps, which was operated by Nazi Germany in occupied Poland during World War II and the Holocaust. It consisted of Auschwitz I, the main camp in Oswiecim; Auschwitz II-Birkenau, a concentration and extermination camp with gas chambers. The camps became a major site of the Nazis’ Final Solution to the Jewish question. 1.1 million people, of which 1 million were Jews, were murdered here between 1941 - 1945. (overnight in Krakow)"
    },
    {
      day: "Day 7 - Sunday, August 23",
      text: "Visit the Wieliczka Salt Mine which is in the town of Wieliczka, near Krakow. The mine was excavated from the 13th century and produced table salt continuously until 1996 as one of the world’s oldest operating salt mines. It reaches a depth of 1,000 feet and extends via horizontal passages and chambers for over 178 miles. It is now a World Heritage site, and its attractions include the shafts and labyrinthine passageways, displays of historic salt-mining technology, an underground lake, four chapels and numerous statues carved by miners out of the rock salt, and more recent sculptures by contemporary artists. It draws 1.2 million people annually. After the tour, we will drive to Zakopane. (overnight in Zakopane)"
    },
    {
      day: "Day 8 - Monday, August 24",
      text: "Some of this day’s adventure will be going to the nearby Tatra National Park and taking the long cable car ride to the top of the Tatra Mountains, which puts us right on the Slovakian border. From there, we can walk/hike across the border. (overnight in Zakopane)"
    },
    {
      day: "Day 9 - Tuesday, August 25",
      text: "This will be a day of rest and relaxation. Several different optional activities will be available, from driving into the Slovakian mountains to hiking on various trails nearby. It will be a free day to do what we want. (overnight in Zakopane)"
    },
    {
      day: "Day 10 - Wednesday, August 26",
      text: "We will drive our rental cars back to Krakow and then ride the bus back to Warsaw and stay at the hotel near the airport. (overnight in Warsaw)"
    },
    {
      day: "Day 11 - Thursday, August 27",
      text: "Fly back to the USA"
    }
  ];
  const tripExample = [
    {
      day: "Day 1",
      text: "Depart USA for Warsaw, Poland"
    },
    {
      day: "Day 2",
      text: "Arrive to Warsaw and get settled into our hotel (overnight in Warsaw)"
    },
    {
      day: "Day 3",
      text: "Tour the historical center of Warsaw with a local guide, visiting both the Old Town and the Warsaw Ghetto. During the Warsaw Uprising in August 1944, more than 85% of Warsaw’s historic center was destroyed by Nazi troops. After the war, a five-year reconstruction campaign by its citizens resulted in today’s meticulous restoration of the Old Town, with its churches, palaces, and marketplace. The Warsaw Ghetto was the largest of the Nazi ghettos during World War II and the Holocaust. It was established in November 1940 by the German authorities. At its height, as many as 460,000 Jews were imprisoned there, in an area of 1.3 sq mi, with an average of 9.2 persons per room, barely subsisting on meager food rations. From the Warsaw Ghetto, Jews were deported to Nazi concentration camps and mass-killing centers. In the summer of 1942, at least 254,000 ghetto residents were sent to the Treblinka extermination camp. (overnight in Warsaw)"
    },
    {
      day: "Day 4",
      text: "Ride a bus from Warsaw to Krakow (4.5 hrs). In the evening, we will stroll through the Main Market Square, the biggest Medieval Plaza in Europe. Its 40,000 square meters are truly astonishing. It was designed in 1257, is considered Kraków’s city center and has an important historical, cultural, and social significance. The entire medieval old town is among the first sites chosen for UNESCO’s original World Heritage List. (overnight in Krakow)"
    },
    {
      day: "Day 5",
      text: "In the morning tour Wawel Hill. In 1978 Wawel was declared the first World Heritage Site as part of the historic center of Kraków. For centuries the residence of the kings of Poland and the symbol of Polish statehood, Wawel Castle is now one of the country’s premier art museums. In the afternoon a Oscar Schindlers’ factory tour. The Oscar Schindler’s Enamel Factory is where 1,200 Jews were employed by Schindler and whose lives were subsequently saved from the death camps. This factory is now a museum. (overnight in Krakow)"
    },
    {
      day: "Day 6",
      text: "Tour Auschwitz/Birkenau, the largest of the Nazi concentration and extermination camps, which was operated by Nazi Germany in occupied Poland during World War II and the Holocaust. It consisted of Auschwitz I, the main camp in Oswiecim; Auschwitz II-Birkenau, a concentration and extermination camp with gas chambers. The camps became a major site of the Nazis’ Final Solution to the Jewish question. 1.1 million people, of which 1 million were Jews, were murdered here between 1941 - 1945. (overnight in Krakow)"
    },
    {
      day: "Day 7",
      text: "Visit the Wieliczka Salt Mine which is in the town of Wieliczka, near Krakow. The mine was excavated from the 13th century and produced table salt continuously until 1996 as one of the world’s oldest operating salt mines. It reaches a depth of 1,000 feet and extends via horizontal passages and chambers for over 178 miles. It is now a World Heritage site, and its attractions include the shafts and labyrinthine passageways, displays of historic salt-mining technology, an underground lake, four chapels and numerous statues carved by miners out of the rock salt, and more recent sculptures by contemporary artists. It draws 1.2 million people annually. After the tour, we will drive to Zakopane. (overnight in Zakopane)"
    },
    {
      day: "Day 8",
      text: "Some of this day’s adventure will be going to the nearby Tatra National Park and taking the long cable car ride to the top of the Tatra Mountains, which puts us right on the Slovakian border. From there, we can walk/hike across the border. (overnight in Zakopane)"
    },
    {
      day: "Day 9",
      text: "This will be a day of rest and relaxation. Several different optional activities will be available, from driving into the Slovakian mountains to hiking on various trails nearby. It will be a free day to do what we want. (overnight in Zakopane)"
    },
    {
      day: "Day 10",
      text: "We will drive our rental cars back to Krakow and then ride the bus back to Warsaw and stay at the hotel near the airport. (overnight in Warsaw)"
    },
    {
      day: "Day 11",
      text: "Fly back to the USA"
    }
  ];

  switch (params.trip) {
    case "August-26":
      dates = "August 17 - 27, 2026";
      trip = tripAugust;
      break;

    case "trip":
      dates = "";
      trip = tripExample;
      break;
  }
  return (
    <div className="pageContainer">
      <p className="title">Itinerary</p>
      <p className="secondaryTitle">{dates}</p>

      <p className="text">
        This trip will have a strong emphasis on WWII, the Holocaust, and the
        strength and resiliency of the Polish people. We will be staying in
        Warsaw, Krakow, and Zakopane. In Warsaw, we will tour with a local guide
        through the old city center and what was once the Jewish Ghetto. After
        taking a bus trip to Krakow, we will tour this charming cultural
        city/center that was once the home of Polish kings. We will visit Wawel
        Hill and the Old City, which has the largest square in all of Europe. We
        will tour Oscar Schindler’s factory (now a museum), where he saved over
        1,200 Jews during WWII. A somber day trip will be spent at the
        Auschwitz/Birkenau concentration and extermination camp. Near Krakow, we
        will visit the Wieleczka Salt Mine, where, hundreds of feet below the
        surface of the ground, we will see churches and cathedrals carved out of
        salt. This is a phenomenal place that most people have never even heard
        of. Lastly, we will drive to the charming town of Zakopane in the
        southern mountains (Tatras) of Poland. This place is the Gatlinburg of
        Poland and the area is called “Little Switzerland." Here, we will spend
        a couple of relaxing days. We will ride a cable car that will transport
        us to the top of the mountains right on the border with Slovakia. This
        will be an exhilarating experience. Trust me! This is the longest cable
        car ride I have ever taken (some 15-20 minutes). The Polish people are
        very friendly, and the food is delicious and quite reasonably priced. If
        you are interested in Poland, this just might be the trip for you.
      </p>
      <div className="pictureRow">
        <div>
          <img className="picture" src={pictureOne} alt="Poland town" />
        </div>
        <div className="hide">
          <img className="picture" src={pictureTwo} alt="Poland solt mines" />
        </div>
        <div>
          <img className="picture" src={pictureThree} alt="Polamd mountains" />
        </div>
      </div>

      {trip.map((item) => (
        <div>
          <h2 className={styles.dayNumber}>{item.day}</h2>
          <p className="text">{item.text}</p>
        </div>
      ))}
    </div>
  );
}

export default PolandItinerary;
